/**
 * Distribution Schedule Page
 *
 * Displays file reports filtered by "Financial Reports" category.
 * This page is a specialized view of the ReportsPage component
 * pre-filtered for distribution schedule documents.
 */

import { ReportsPage } from './ReportsPage';

export const DistributionSchedulePage = () => {
  return <ReportsPage category="Financial Reports" title="Distribution Schedule" />;
};
